import { render, staticRenderFns } from "./WaggonInfoStatus.component.vue?vue&type=template&id=208f274d&"
import script from "./WaggonInfoStatus.component.vue?vue&type=script&lang=js&"
export * from "./WaggonInfoStatus.component.vue?vue&type=script&lang=js&"
import style0 from "./WaggonInfoStatus.component.vue?vue&type=style&index=0&id=208f274d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports